import type { HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

export interface LabelPrimaryProps extends HTMLAttributes<HTMLDivElement> {
  variant: 'news' | 'letters'
  title: string
}

export function LabelPrimary({ variant, title }: LabelPrimaryProps) {
  return (
    <div className="mb-4 flex">
      <h2
        className={twMerge(
          'text-nowrap border-b-2 px-3 text-xl font-bold lg:text-3xl',
          variant === 'news'
            ? 'border-publication-news text-publication-news'
            : 'text-bios-500 border-bios-500',
        )}
      >
        {title}
      </h2>
      <span
        className={twMerge(
          'w-full border-b',
          variant === 'news' ? 'border-publication-news' : 'border-bios-500',
        )}
      ></span>
    </div>
  )
}
